import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Shield, X } from 'lucide-react';
import { Button } from './ui/button';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      // Pequeno delay para não atrapalhar o carregamento inicial
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
    // Ativar Google Analytics após consentimento
    if (window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: 'granted',
      });
    }
  };

  const acceptEssential = () => {
    localStorage.setItem('cookie_consent', 'essential');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[60] p-4 md:p-6 animate-in slide-in-from-bottom duration-500">
      <div className="max-w-4xl mx-auto bg-white border border-gray-200 rounded-2xl shadow-2xl shadow-black/10 p-5 md:p-6">
        <div className="flex items-start gap-4">
          <div className="hidden sm:flex items-center justify-center h-10 w-10 rounded-xl bg-[#0b3d5c]/5 text-[#0b3d5c] shrink-0 mt-0.5">
            <Shield className="h-5 w-5" />
          </div>
          <div className="flex-1 space-y-3">
            <div className="flex items-start justify-between gap-4">
              <div>
                <h3 className="font-semibold text-gray-900 text-sm">Privacidade e Cookies</h3>
                <p className="text-gray-500 text-xs leading-relaxed mt-1">
                  Utilizamos cookies essenciais para o funcionamento do site e cookies analíticos para melhorar sua experiência. 
                  Ao clicar em "Aceitar todos", você concorda com o uso de todos os cookies conforme nossa{' '}
                  <Link to="/privacidade" className="text-[#0b3d5c] underline underline-offset-2 hover:text-[#0a3350]">
                    Política de Privacidade
                  </Link>.
                </p>
              </div>
              <button onClick={acceptEssential} className="text-gray-400 hover:text-gray-600 transition-colors shrink-0 p-1" aria-label="Fechar">
                <X className="h-4 w-4" />
              </button>
            </div>
            <div className="flex flex-col sm:flex-row gap-2">
              <Button onClick={acceptAll} size="sm" className="bg-[#0b3d5c] hover:bg-[#0a3350] rounded-lg text-xs h-8 px-4">
                Aceitar todos
              </Button>
              <Button onClick={acceptEssential} size="sm" variant="outline" className="rounded-lg text-xs h-8 px-4">
                Apenas essenciais
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
